import { DateTime } from 'luxon';

export function validateTripDate(value: any) {
  if (!value) {
    return 'Trip Date is required';
  }

  const date = DateTime.fromISO(value).startOf('day');
  if (date < DateTime.local().startOf('day')) {
    return 'Trip Date must be in the future';
  }
  return true;
}

export function validateTripMaxFutureDate(value: any) {
  if (!value) {
    return 'Trip Date is required';
  }

  const maxFutureDate = DateTime.local().plus({ years: 2 }).endOf('day');
  const date = DateTime.fromISO(value).startOf('day');

  if (date > maxFutureDate) {
    return 'Trip Date must be within the next 2 years';
  }

  return true;
}
